import { InjectionToken } from '@angular/core';
import { Enum } from '../../common/interfaces/enum.interface';

export const ROLES_TYPE = new InjectionToken<Enum>('rolesType');

